const isBambee = () => window.partner === "bambee" || window.location.pathname.slice(0, 7) === "/bambee";

export default isBambee;
